import { useContext } from 'react'
import { useAccess } from '../access'
import { useListingError } from '../listing'

// Context
import { ZillowContext } from '../../contexts'

import Unauthorized from '../../components/Popup/Popups/Errors/Unauthorized'
import Forbidden from '../../components/Popup/Popups/Errors/Forbidden'
import Standard from '../../components/Popup/Popups/Errors/Standard'
import NoHomeDetailsError from '../../components/Popup/Popups/Errors/NoHomeDetailsError'

const useErrorPopup = () => {
  const { isUnauthorized, isForbidden, isError: anyAccessError } = useAccess()
  const { isZillowDomError, isError: anyListingError } = useListingError()

  const { userManuallyEntered } = useContext(ZillowContext)

  if (!anyAccessError && !anyListingError) {
    return hidePopup()
  } else if (isUnauthorized) {
    return displayPopup(Unauthorized)
  } else if (isForbidden) {
    return displayPopup(Forbidden)
  } else if (isZillowDomError && !userManuallyEntered) {
    return displayPopup(NoHomeDetailsError)
  } else {
    return displayPopup(Standard)
  }
}

const displayPopup = popup => ({ showPopup: true, popup })

const hidePopup = () => ({ showPopup: false, popup: null })

export default useErrorPopup
